import React from 'react';
import { Collapse as BPCollapse, CollapseProps } from '@blueprintjs/core';

const BareCollapse: React.FC<CollapseProps> = (props) => {
  return <BPCollapse {...props} />;
};

export default BareCollapse;
